import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const ANIMAL = {
  nickname: 'PRODUCTS.ANIMAL.shortname',
  propertiesProductsList: {
    name: 'animalList',
    properties: [
      { name: 'animalBreed', key: 'ANIMAL_BREED', group: 'INSURANCE_INFO' },
      { name: 'animalBreedType', key: 'ANIMAL_BREED_TYPE', group: 'INSURANCE_INFO' },
      { name: 'animalType', key: 'ANIMAL_TYPE', group: 'INSURANCE_INFO' },
      { name: 'animalSIIllness', key: 'ANIMAL_ILLNESS_SCOOPR', group: 'INSURANCE_INFO' },
      { name: 'animalDeathCoverage', key: 'ANIMAL_DEATH_COVERAGE', group: 'INSURANCE_INFO' },
      { name: 'animalSIDeath', key: 'ANIMAL_DEATH_SCOOPR', group: 'INSURANCE_INFO' },
      { name: 'animalBirthYear', key: 'ANIMAL_BIRTH_YEAR', group: 'OBJECT_INFO' }
    ]
  },
  properties: [
    {
      name: 'animalName', key: 'ANIMAL_NAME', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['']
    },
    {
      name: 'animalType', key: 'ANIMAL_TYPE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED.CAT', value: 'CAT' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED.DOG', value: 'DOG' }
        ]
      }
    },
    {
      name: 'animalBirthDay', key: 'ANIMAL_BIRTH_DATE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'month'
      }
    },
    {
      name: 'animalSIIllness', key: 'ANIMAL_ILLNESS_SUM', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      ANIMAL_ILLNESS_SUM_INSURED_RANGE_FROM_1: true,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^\d+$/),
        Validators.min(1),
        Validators.max(50000)
      ]]
    },
    {
      name: 'animalLivestockMarkingMembership', key: 'ANIMAL_LIVESTOCK_MARKING_MEMBERSHIP', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      isStormAnimalIdCheck: true,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.ANIMAL_LIVESTOCK_MARKING_MEMBERSHIP.LIVESTOCK_ID_MARKING', value: 'LIVESTOCK_ID_MARKING' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ANIMAL_LIVESTOCK_MARKING_MEMBERSHIP.LIVESTOCK_MEMBER_NKK', value: 'LIVESTOCK_MEMBER_NKK' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ANIMAL_LIVESTOCK_MARKING_MEMBERSHIP.NONE', value: 'NONE' }
        ]
      }
    },
    {
      name: 'animalId', key: 'ANIMAL_ID', group: 'OBJECT_INFO'
    },
    {
      name: 'animalBreed', key: 'ANIMAL_BREED', group: 'INSURANCE_INFO',
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: []
      },
      customValueConfig: {
        CAT: {
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.1', value: 'Abyssiner' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.2', value: 'American Curl Korthår' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.3', value: 'American Curl Langhår' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.5', value: 'Balineser' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.6', value: 'Bengal' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.7', value: 'Birma' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.8', value: 'Blandingsrase' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.9', value: 'Britisk korthår' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.10', value: 'Burmeser' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.11', value: 'Burmilla' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.12', value: 'Chartreux' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.13', value: 'Cornish Rex' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.14', value: 'Devon Rex' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.15', value: 'Egyptisk Mau' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.16', value: 'Europe' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.17', value: 'Exotic' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.18', value: 'German Rex' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.19', value: 'Hellig Birma' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.20', value: 'Japanese Bobtail' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.21', value: 'Khao Manee' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.22', value: 'Korat' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.23', value: 'Kurilsk Bobtail Korthår' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.24', value: 'Kurilsk Bobtail Langhår' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.25', value: 'Maine Coon' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.26', value: 'Manx' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.27', value: 'Minskin' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.28', value: 'Munchkin' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.29', value: 'Norsk Skogkatt' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.30', value: 'Ocicat' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.31', value: 'Orientalsk Korthår' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.32', value: 'Orientalsk Langhår' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.33', value: 'Perser' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.34', value: 'Pixie-Bob' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.35', value: 'Ragdoll' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.36', value: 'Russian Blue' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.37', value: 'Savannah' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.38', value: 'Scottish Fold' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.39', value: 'Siameser' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.40', value: 'Sibir' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.41', value: 'Snowshoe' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.42', value: 'Sokoke' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.43', value: 'Somali' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.44', value: 'Sphynx' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.45', value: 'Teacup Persians' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_CAT.46', value: 'Tyrkisk Angora' },
            ]
          }
        },
        DOG: {
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.423', value: 'Affenpincher' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.1', value: 'Afrikansk Mynde' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.2', value: 'Airedale Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.424', value: 'Alabai Rase' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.3', value: 'Alaskan Husky' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.4', value: 'Alaskan Malamute' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.5', value: 'American Bulldog' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.6', value: 'American Bully (Standard)' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.7', value: 'American Eskimo Dog (Miniature)' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.8', value: 'American Eskimo Dog (Standard)' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.9', value: 'American Pit Bull Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.10', value: 'Amerikansk Akita' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.11', value: 'Amerikansk Cocker Spaniel' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.12', value: 'Amerikansk Foxhound' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.13', value: 'Amerikansk Staffordshire Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.14', value: 'Amerikansk Vannspaniel' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.16', value: 'Australian Cattle Dog (Heeler)' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.17', value: 'Australian Kelpie' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.18', value: 'Australian Shepherd' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.19', value: 'Australsk Cobberdog' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.20', value: 'Australsk Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.21', value: 'Barbet' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.22', value: 'Basenji' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.23', value: 'Basset Hound' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.425', value: 'Bayersk Viltsporhund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.24', value: 'Beagle' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.25', value: 'Bearded Collie' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.26', value: 'Beauceron' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.27', value: 'Bedlington Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.28', value: 'Belgian Malinois' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.29', value: 'Belgian Tervuren' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.30', value: 'Berner Sennenhund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.31', value: 'Bichon Frise' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.32', value: 'Bichon Havanais' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.33', value: 'Black and Tan Coonhound' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.35', value: 'Blodhund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.36', value: 'Bluetick Coonhound' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.37', value: 'Boerboel' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.38', value: 'Border Collie' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.39', value: 'Border Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.40', value: 'Borzoi' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.41', value: 'Boston Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.42', value: 'Bouvier des Flandres' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.43', value: 'Boxer' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.44', value: 'Bracco Italiano' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.45', value: 'Breton' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.46', value: 'Briard' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.47', value: 'Brittany' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.48', value: 'Bull Terrier (Miniature)' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.49', value: 'Bull Terrier (Standard)' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.50', value: 'Bulldog' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.51', value: 'Bullmastiff' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.52', value: 'Cairn Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.53', value: 'Cane Corso' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.54', value: 'Cardigan Welsh Corgi' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.55', value: 'Caucasian Shepherd (Ovcharka)' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.56', value: 'Cavalier King Charles Spaniel' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.246', value: 'Cavapoo' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.57', value: 'Chesapeake Bay Retriever' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.58', value: 'Chihuahua' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.59', value: 'Chinese Crested' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.61', value: 'Chow Chow' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.62', value: 'Clumber Spaniel' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.426', value: 'Cocapoo' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.63', value: 'Cocker Spaniel' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.64', value: 'Collie' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.65', value: 'Coton De Tulear' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.66', value: 'Curly-Coated Retriever' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.67', value: 'Dachshund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.68', value: 'Dalmatiner' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.69', value: 'Dansk-Svensk Gårdshund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.70', value: 'Dobermann' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.71', value: 'Dogo Argentino' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.427', value: 'Dogue de Bordeaux' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.72', value: 'Drever' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.73', value: 'Dvergpincher' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.74', value: 'Dvergpuddel' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.75', value: 'Dvergschnauzer' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.76', value: 'Engelsk Bulldog' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.77', value: 'Engelsk Cocker Spaniel' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.78', value: 'Engelsk Setter' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.79', value: 'Engelsk springer spaniel' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.80', value: 'English Toy Spaniel' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.81', value: 'English Toy Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.82', value: 'Eurasier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.83', value: 'Field Spaniel' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.428', value: 'Fila Brasileiro' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.84', value: 'Finnish Spitz' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.85', value: 'Finsk Lapphund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.429', value: 'Finsk Støver' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.86', value: 'Flat-Coated Retriever' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.87', value: 'Fox Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.176', value: 'Fox Terrier, glatthåret' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.88', value: 'Fransk Bulldog' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.89', value: 'Fuglehund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.90', value: 'German Pinscher' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.91', value: 'German Shorthaired Pointer' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.92', value: 'Giant Schnauzer' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.93', value: 'Glen of Imaal Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.94', value: 'Golden Retriever' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.95', value: 'Goldendoodle' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.96', value: 'Gordon Setter' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.97', value: 'Grand Danois' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.98', value: 'Greyhound' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.99', value: 'Grosser Münsterländer' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.100', value: 'Grønlandshund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.101', value: 'Hamiltonstøver' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.102', value: 'Harrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.104', value: 'Hvit gjerterhund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.105', value: 'Irish Soft Coated Wheaten Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.106', value: 'Irsk Setter' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.107', value: 'Irsk Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.108', value: 'Irsk Ulvehund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.109', value: 'Islandsk Fårehund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.110', value: 'Italiensk Mynde' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.179', value: 'Italiensk Spinone' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.111', value: 'Jack Russell Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.112', value: 'Japanese Chin' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.113', value: 'Japansk Spisshund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.430', value: 'Jämthund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.114', value: 'Keeshond' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.KLEINSPITZ', value: 'Klein Spitz' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.115', value: 'Kleiner Münsterländer' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.116', value: 'Komondor' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.117', value: 'Kooikerhondje' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.118', value: 'Kuvasz' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.119', value: 'Labradoodle' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.120', value: 'Labrador Retriever' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.121', value: 'Lagotto Romagnolo' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.431', value: 'Lakelandterrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.122', value: 'Lancashire Heeler' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.432', value: 'Lapsk Vallhund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.123', value: 'Leonberger' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.124', value: 'Lhasa Apso' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.125', value: 'Maltese' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.327', value: 'Maltipoo' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.126', value: 'Meksikansk Nakenhund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.127', value: 'Mellompuddel' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.128', value: 'Miniature American Shepherd' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.433', value: 'Mittelspitz' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.130', value: 'Napolitansk Mastiff' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.131', value: 'Newfoundlandshund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.132', value: 'Norfolk Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.133', value: 'Norrbottenspets' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.134', value: 'Norsk Buhund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.135', value: 'Norsk Elghund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.136', value: 'Norsk Elghund svart' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.137', value: 'Norsk Lundehund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.138', value: 'Norwich Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.139', value: 'Nova Scotia Duck Tolling Retriever' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.140', value: 'Old English Sheepdog' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.141', value: 'Olde English Bulldogge' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.142', value: 'Papillon' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.434', value: 'Parson Russel-Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.143', value: 'Pekingese' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.144', value: 'Pembroke Welsh Corgi' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.145', value: 'Phalène' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.146', value: 'Pharaoh Hound' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.435', value: 'Picard' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.147', value: 'Plott' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.436', value: 'Podengo Portugues' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.148', value: 'Pointer' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.350', value: 'PomChi' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.149', value: 'Pomeranian' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.150', value: 'Portugisisk Vannhund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.151', value: 'Presa Canario' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.152', value: 'Puddel' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.437', value: 'Pug / Mops' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.154', value: 'Puli' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.155', value: 'Pumi' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.156', value: 'Pyrenéerhund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.157', value: 'Redbone Coonhound' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.158', value: 'Rhodesian Ridgeback' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.159', value: 'Rottweiler' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.160', value: 'Russisk Toy Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.161', value: 'Russisk-Europeisk Laika' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.438', value: 'Russkaya Tsvetnaya Bolonka' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.162', value: 'Saluki' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.163', value: 'Samoyed' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.164', value: 'Sankt Bernhard' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.167', value: 'Schaefer' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.165', value: 'Schipperke' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.166', value: 'Schnauzer' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.374', value: 'Schnoodle' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.169', value: 'Scottish Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.60', value: 'Shar Pei' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.60', value: 'Shar-Pei' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.171', value: 'Shetland Sheepdog' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.172', value: 'Shiba Inu' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.173', value: 'Shih Tzu' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.174', value: 'Siberian Husky' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.175', value: 'Silky Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.168', value: 'Skotsk hjortehund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.177', value: 'Soft Coated Wheaten Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.178', value: 'Spansk Vannhund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.180', value: 'Spitz Pomerian' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.439', value: 'Stabijhoun' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.181', value: 'Staffordshire Bull Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.182', value: 'Standard Schnauzer' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.183', value: 'Storpuddel' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.440', value: 'Svensk Lapphund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.184', value: 'Thai Ridgeback' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.185', value: 'Tibetansk Mastiff' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.186', value: 'Tibetansk Spaniel' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.187', value: 'Tibetansk Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.441', value: 'Tosa' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.188', value: 'Toy Fox Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.189', value: 'Toy Puddel' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.442', value: 'Tsjekkoslovakisk Ulvehund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.190', value: 'Vestsibirsk Laika' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.191', value: 'Vizsla' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.192', value: 'Vorstehhund' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.193', value: 'Västgötaspets' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.194', value: 'Weimaraner' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.195', value: 'Welsh Springer Spaniel' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.196', value: 'West Highland Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.197', value: 'Whippet' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.419', value: 'Working Cocker' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.198', value: 'Xoloitzcuintli' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.199', value: 'Yorkshire Terrier' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PET_BREED_DOG.200', value: 'Østsibirsk Laika' },
            ]
          }
        }
      }
    },
    {
      name: 'animalBreedType', key: 'ANIMAL_BREED_TYPE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      isStormAnimalBreedCheck: true,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.ANIMAL_BREED_TYPE.PUREBRED', value: 'PUREBRED' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ANIMAL_BREED_TYPE.MIXED_BREED', value: 'MIXED_BREED' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ANIMAL_BREED_TYPE.UNKNOWN', value: 'UNKNOWN' }
        ]
      }
    },
    {
      name: 'animalDeathCoverage', key: 'ANIMAL_DEATH_COVERAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      isStormAnimalDeathSumCheck: true,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'animalSIDeath', key: 'ANIMAL_DEATH_SUM', group: 'INSURANCE_INFO',
      ANIMAL_DEATH_SUM_INSURED_RANGE: false,
      ANIMAL_DEATH_SUM_INSURED_RANGE_FROM_5000: true,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^\d+$/),
        Validators.min(5000),
        Validators.max(50000)
      ]]
    },
    {
      name: 'animalHealthyNoDefects', key: 'ANIMAL_HEALTHY', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    }
  ],
  icon: 'animal'
};
